<template>
  <!-- <article class="message is-info is-pulled-right">
    <div class="message-header">
      <p>{{ $t("information") }}</p>
    </div>
    <div class="message-body">
      {{ $t("you can reorder modules by dragging and dropping") }}
    </div>
  </article> -->
  <div class="container section p-0">
    <div class="mt-0">
      <div class="columns">
        <div class="column is-4">
          <h1 class="title is-4">{{ $t("modules") }}</h1>
        </div>
        <div class="column is-8">
          <p class="buttons is-pulled-right">
            <button
              class="button"
              @click="update_git"
              :data-tooltip="$t('update')"
              v-bind:class="{ 'is-loading': is_waiting_for_update }"
            >
              <span class="icon has-text-info">
                <i class="fa fa-git"></i>
              </span>
              <!-- <span>{{ $t("make build") }}</span> -->
            </button>
            <button
              class="button"
              @click="import_module"
              :data-tooltip="$t('import')"
            >
              <span class="icon has-text-warning">
                <i class="fa fa-download"></i>
              </span>
            </button>
            <button
              class="button"
              @click="generate_build"
              :data-tooltip="$t('make build')"
              v-bind:class="{ 'is-loading': is_waiting_for_build }"
            >
              <span class="icon has-text-success">
                <i class="fa fa-rocket"></i>
              </span>
              <!-- <span>{{ $t("make build") }}</span> -->
            </button>
            <button
              class="button"
              @click="build_custom_build"
              :data-tooltip="$t('generate custom_build file')"
            >
              <span class="icon has-text-danger">
                <i class="fa fa-file-text-o"></i>
              </span>
              <!-- <span>{{ $t("generate custom_build file") }}</span> -->
            </button>
            <button class="button is-rounded" @click="create">
              <span class="icon has-text-warning">
                <i class="fa fa-modx"></i>
              </span>
              <span>{{ $t("create module") }}</span>
            </button>
            <button class="button is-rounded" @click="generate">
              <span class="icon has-text-info">
                <i class="fa fa-bolt"></i>
              </span>
              <span>{{ $t("generate module") }}</span>
            </button>
            <button class="button is-primary is-rounded" @click="init">
              <span class="icon">
                <i class="fa fa-refresh"></i>
              </span>
              <span>{{ $t("refresh") }}</span>
            </button>
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column"></div>
        <div class="has-text-centered column is-4">
          <input
            class="input is-rounded"
            type="text"
            :placeholder="$t('search module')"
            v-model="search"
          />
        </div>
        <div class="column"></div>
      </div>

      <draggable
        class="grid is-col-min-7 installed"
        v-model="installed_modules"
        group="modules"
        item-key="uuid"
        @change="move"
      >
        <template #item="{ element }">
          <div class="cell">
            <div class="card">
              <div class="card-image">
                <div
                  class="dropdown is-pulled-right"
                  @mouseover="show_menu(element)"
                  @mouseleave="hide_menu(element)"
                >
                  <div class="dropdown-trigger">
                    <div
                      class="tag"
                      aria-haspopup="true"
                      aria-controls="dropdown-menu"
                      :data-tooltip="$t('options')"
                    >
                      <span
                        class="icon is-small"
                        :class="{
                          'has-text-primary': element.has_technical_docs,
                          'has-text-danger': !element.has_technical_docs,
                        }"
                      >
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                  <div class="dropdown-menu options-menu" role="menu">
                    <div class="dropdown-content">
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="install_module(element)"
                        v-if="!element.exist_in_database"
                      >
                        <span class="icon has-text-info">
                          <i class="fa fa-bolt"></i>
                        </span>
                        <span>{{ $t("install") }}</span>
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="uninstall_module(element)"
                        v-if="
                          element.exist_in_database &&
                          element.is_uninstallable != false
                        "
                      >
                        <span class="icon has-text-danger">
                          <i class="fa fa-unlink"></i>
                        </span>
                        <span>{{ $t("uninstall") }}</span></a
                      >
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="configure(element)"
                        v-if="
                          element.exist_in_database && element.is_configurable
                        "
                      >
                        <span class="icon has-text-info">
                          <i class="fa fa-cog"></i>
                        </span>
                        <span>{{ $t("configure") }}</span>
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="permissions(element)"
                        v-if="element.exist_in_database"
                      >
                        <span class="icon has-text-warning">
                          <i class="fa fa-key"></i>
                        </span>
                        <span>{{ $t("permissions") }}</span>
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="rebuild_permissions(element)"
                        v-if="element.exist_in_database"
                      >
                        <span class="icon">
                          <i class="fa fa-bolt"></i>
                        </span>
                        <span>{{ $t("rebuild permissions") }}</span>
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="define(element)"
                      >
                        <span class="icon has-text-primary">
                          <i class="fa fa-cogs"></i>
                        </span>
                        <span>{{ $t("definition") }}</span>
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="clone(element)"
                        v-if="element.is_clonable != false"
                      >
                        <span class="icon">
                          <i class="fa fa-clone"></i>
                        </span>
                        <span>{{ $t("clone") }}</span>
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="remove(element)"
                        v-if="
                          !element.exist_in_database &&
                          element.is_eliminable != false
                        "
                      >
                        <span class="icon has-text-danger">
                          <i class="fa fa-trash"></i>
                        </span>
                        <span>{{ $t("delete") }}</span>
                      </a>
                      <a
                        href="#"
                        class="dropdown-item"
                        @click="technical_docs(element)"
                        v-if="element.has_technical_docs == true"
                      >
                        <span class="icon has-text-info">
                          <i class="fa fa-book"></i>
                        </span>
                        <span>{{ $t("technical documentation") }}</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="tag is-pulled-right"
                  :data-tooltip="$t('not installed')"
                  v-if="!element.exist_in_database"
                >
                  <span class="icon is-small has-text-warning">
                    <i class="fa fa-warning" aria-hidden="true"></i>
                  </span>
                </div>
                <!-- <a
                  href="#"
                  class="dropdown-item"
                  v-if="element.has_technical_docs == true"
                >
                  <span
                    class="icon has-text-warning"
                    :data-tooltip="$t('technical documentation')"
                  >
                    <i class="fa fa-book"></i>
                  </span>
                </a> -->
                <!-- <div
                  class="tag is-pulled-right"
                  :data-tooltip="$t('installed')"
                  v-if="element.exist_in_database"
                >
                  <span class="icon is-small has-text-primary">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </span>
                </div> -->

                <figure
                  class="image is-64x64 m-auto py-4"
                  v-bind:style="[
                    element.matches_search ? { opacity: 1 } : { opacity: 0.3 },
                  ]"
                >
                  <img
                    :src="element.home_icon || 'https://via.placeholder.com/48'"
                  />
                </figure>
              </div>
              <div class="card-content px-0">
                <div class="media">
                  <div class="media-content">
                    <p
                      class="title is-5 has-text-centered"
                      v-bind:class="{
                        'has-text-grey': !element.exist_in_database,
                        'has-text-grey-dark': !element.matches_search,
                      }"
                    >
                      {{ $t(element.home_title) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </draggable>
      <div class="is-divider" v-if="uninstalled_modules.length"></div>
      <div class="title is-4" v-if="uninstalled_modules.length">
        {{ $t("not installed modules") }}
      </div>
      <div class="fixed-grid has-5-cols">
        <draggable
          class="grid uninstalled"
          v-model="uninstalled_modules"
          group="modules"
          item-key="uuid"
          @change="move"
        >
          <template #item="{ element }">
            <div class="cell">
              <div class="card">
                <div class="card-image">
                  <div
                    class="dropdown is-pulled-right"
                    @mouseover="show_un_menu(element)"
                    @mouseleave="hide_un_menu(element)"
                  >
                    <div class="dropdown-trigger">
                      <div
                        class="tag"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        :data-tooltip="$t('options')"
                      >
                        <span class="icon is-small has-text-primary">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                    <div class="dropdown-menu options-menu" role="menu">
                      <div class="dropdown-content">
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="install_module(element)"
                          v-if="!element.exist_in_database"
                        >
                          <span class="icon has-text-info">
                            <i class="fa fa-bolt"></i>
                          </span>
                          <span>{{ $t("install") }}</span>
                        </a>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="uninstall_module(element)"
                          v-if="
                            element.exist_in_database &&
                            element.is_uninstallable != false
                          "
                        >
                          <span class="icon has-text-danger">
                            <i class="fa fa-unlink"></i>
                          </span>
                          <span>{{ $t("uninstall") }}</span></a
                        >
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="configure(element)"
                          v-if="
                            element.exist_in_database && element.is_configurable
                          "
                        >
                          <span class="icon has-text-info">
                            <i class="fa fa-cog"></i>
                          </span>
                          <span>{{ $t("configure") }}</span>
                        </a>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="permissions(element)"
                          v-if="element.exist_in_database"
                        >
                          <span class="icon has-text-warning">
                            <i class="fa fa-key"></i>
                          </span>
                          <span>{{ $t("permissions") }}</span>
                        </a>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="rebuild_permissions(element)"
                          v-if="element.exist_in_database"
                        >
                          <span class="icon">
                            <i class="fa fa-bolt"></i>
                          </span>
                          <span>{{ $t("rebuild permissions") }}</span>
                        </a>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="define(element)"
                        >
                          <span class="icon has-text-primary">
                            <i class="fa fa-cogs"></i>
                          </span>
                          <span>{{ $t("definition") }}</span>
                        </a>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="clone(element)"
                          v-if="element.is_clonable != false"
                        >
                          <span class="icon">
                            <i class="fa fa-clone"></i>
                          </span>
                          <span>{{ $t("clone") }}</span>
                        </a>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="remove(element)"
                          v-if="
                            !element.exist_in_database &&
                            element.is_eliminable != false
                          "
                        >
                          <span class="icon has-text-danger">
                            <i class="fa fa-trash"></i>
                          </span>
                          <span>{{ $t("delete") }}</span>
                        </a>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="technical_docs(element)"
                          v-if="element.has_technical_docs == true"
                        >
                          <span class="icon has-text-info">
                            <i class="fa fa-book"></i>
                          </span>
                          <span>{{ $t("technical documentation") }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tag is-pulled-right"
                    :data-tooltip="$t('not installed')"
                    v-if="!element.exist_in_database"
                  >
                    <span class="icon is-small has-text-warning">
                      <i class="fa fa-warning" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div
                    class="tag is-pulled-right"
                    :data-tooltip="$t('installed')"
                    v-if="element.exist_in_database"
                  >
                    <span class="icon is-small has-text-primary">
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </span>
                  </div>

                  <figure class="image is-64x64 m-auto py-4">
                    <img
                      :src="
                        element.home_icon || 'https://via.placeholder.com/48'
                      "
                    />
                  </figure>
                </div>
                <div class="card-content px-0">
                  <div class="media">
                    <div class="media-content">
                      <p
                        class="title is-5 has-text-centered"
                        v-bind:class="{
                          'has-text-grey': !element.exist_in_database,
                        }"
                      >
                        {{ $t(element.home_title) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </draggable>
      </div>
    </div>
    <permissions-modal ref="permissions_modal" />
    <define-modal ref="define_modal" @success="init" />
    <create-modal ref="create_modal" @success="init" />
    <generate-modal ref="generate_modal" @success="init" />
    <import-modal ref="import_modal" />
  </div>
</template>

<script>
import {
  get,
  error_message,
  put,
  del,
  post,
  confirm_deletion_dialog,
  get_permissions,
  success_message,
} from "@/utils";
import PermissionsModal from "./permissions_modal/Index";
import DefineModal from "./define_modal/Index";
import CreateModal from "./create_modal/Index";
import GenerateModal from "./generate_modal/Index";
import ImportModal from "./import_modal/Index";
import draggable from "vuedraggable";
// import draggable from "vuedraggable/dist/vuedraggable.umd";

export default {
  name: "SettingModuleManager",
  components: {
    PermissionsModal,
    DefineModal,
    CreateModal,
    GenerateModal,
    ImportModal,
    draggable,
  },
  data() {
    return {
      modules: [],
      installed_modules: [],
      uninstalled_modules: [],
      is_waiting_for_build: false,
      is_waiting_for_update: false,
      myArray: [
        { id: 1, name: "John Doe" },
        { id: 2, name: "Jane Doe" },
        { id: 3, name: "Jake Doe" },
        { id: 4, name: "Jesse Doe" },
      ],
      drag: false,
      search: "",
    };
  },
  computed: {},
  methods: {
    init() {
      let v = this;
      v.$root.loader(true);
      get("/module/all", {})
        .then((r) => {
          // console.log("modules", r);
          let indexed = r
            .filter((m) => m.last_index_update_date)
            .sort((a, b) => {
              if (a.index < b.index) return -1;
              else if (a.index > b.index) return 1;
              else if (a.index == b.index) {
                if (a.last_index_update_date < b.last_index_update_date)
                  return -1;
                else if (a.last_index_update_date > b.last_index_update_date)
                  return 1;
                else if (a.last_index_update_date == b.last_index_update_date)
                  return 0;
              }
            });
          let not_indexed = r.filter((m) => !m.last_index_update_date);
          v.modules = indexed.concat(not_indexed);
          v.installed_modules = v.modules
            .filter((m) => m.exist_in_database)
            .map((m) => {
              m.matches_search = true;
              return m;
            });
          v.uninstalled_modules = v.modules
            .filter((m) => !m.exist_in_database)
            .map((m) => {
              m.matches_search = true;
              return m;
            });
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    install_module(mdle) {
      let v = this;
      v.$root.loader(true);
      put("/module/install", { code_name: mdle.code_name })
        .then(() => {
          success_message(v.$t("module installed"));
          v.init();
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    uninstall_module(mdle) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to uninstall this module?"),
        v,
        () => {
          v.$root.loader(true);
          del("/module/install", { module_id: mdle.module_id })
            .then(() => {
              success_message(v.$t("module uninstalled"));
              v.init();
            })
            .catch((error) => {
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
    configure(mdle) {
      //   let v = this;
      //   v.$refs.permissions_modal.show_modal(mdle.module_id);
      // console.log("configuration of module", mdle);
      this.$router.push({ path: `/${mdle.code_name}/settings` });
    },
    permissions(mdle) {
      let v = this;
      v.$refs.permissions_modal.show_modal(mdle.module_id);
    },
    define(mdle) {
      // console.log("mdle.code_name", mdle.code_name);
      let v = this;
      v.$refs.define_modal.show_modal(mdle.code_name);
    },
    create() {
      let v = this;
      v.$refs.create_modal.show_modal();
    },
    generate() {
      let v = this;
      v.$refs.generate_modal.show_modal();
    },
    build_custom_build() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to generate custom_build file?"),
        v,
        () => {
          v.$root.loader(true);
          put("/module/custom_build", {})
            .then(() => {
              // console.log("build_custom_routes finished");
              success_message(v.$t("custom_build file generated"));
            })
            .catch((error) => {
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
    generate_build() {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to make build?"), v, () => {
        v.$root.loader(true);
        put("/module/build", { _timeout: 60000 * 3 })
          .then((stdout) => {
            console.log("build finished", stdout);
            success_message(v.$t("build finished"));
            setTimeout(() => {
              location.reload(true);
            }, 1000);
            // success_message(stdout);
          })
          .catch((error) => {
            error_message(error);
          })
          .finally(() => {
            v.$root.loader(true);
          });
      });
    },
    update_git() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to update from repository?"),
        v,
        () => {
          v.$root.loader(true);
          v.is_waiting_for_build = true;
          put("/module/update", {})
            .then((stdout) => {
              success_message(stdout);
              // success_message(stdout);
            })
            .catch((error) => {
              error_message(error);
            })
            .finally(() => {
              v.is_waiting_for_build = false;
              v.$root.loader(false);
            });
        }
      );
    },
    remove(mdle) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to remove this module?"),
        v,
        () => {
          v.$root.loader(true);
          del("/module", { code_name: mdle.code_name })
            .then(() => {
              success_message(v.$t("module removed"));
              v.init();
            })
            .catch((error) => {
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
    rebuild_permissions(mdle) {
      let v = this;
      v.$root.loader(true);
      put("/module/rebuild_permissions", {
        code_name: mdle.code_name,
        module_id: mdle.module_id,
      })
        .then(() => {
          // console.log("permission rebuilt");
          success_message(this.$t("permissions rebuilt"));
          get("/system/authentication/reload-session")
            .then((permissions) => {
              localStorage.removeItem("permissions");

              let perms = get_permissions();
              // console.log("perms", perms);
              localStorage.setItem(
                "permissions",
                JSON.stringify(permissions.concat(perms))
              );

              success_message(v.$t("session reloaded"));
            })
            .catch((error) => {
              console.error("error", error);
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    generate_language(mdle) {
      // let v = this;
      put("/module/generate-language", {
        code_name: mdle.code_name,
      })
        .then(() => {
          // console.log("language generated");
          success_message(this.$t("language generated"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
    clone(mdle) {
      let v = this;
      v.$refs.create_modal.clone_modal(mdle);
    },
    import_module() {
      let v = this;
      v.$refs.import_modal.show_modal();
    },
    hide_menu(element) {
      let v = this;
      let index = v.installed_modules.findIndex(
        (m) => m.code_name == element.code_name
      );
      if (index > -1) {
        let menus = window.jQuery(".installed .dropdown.is-pulled-right");
        let trgt = menus[index];
        trgt.classList.remove("is-active");
      }
    },
    show_menu(element) {
      let v = this;
      let index = v.installed_modules.findIndex(
        (m) => m.code_name == element.code_name
      );
      if (index > -1) {
        let menus = window.jQuery(".installed .dropdown.is-pulled-right");
        let trgt = menus[index];
        trgt.classList.add("is-active");

        window
          .jQuery(trgt)
          .find(".dropdown-item")
          .on("click", function () {
            trgt.classList.remove("is-active");
          });

        // window.jQuery(trgt).on("click", function () {
        //   trgt.classList.remove("is-active");
        // });

        for (let i = 0; i < menus.length; i++) {
          if (i != index) {
            menus[i].classList.remove("is-active");
          }
        }
      }
    },
    hide_un_menu(element) {
      let v = this;
      let index = v.uninstalled_modules.findIndex(
        (m) => m.code_name == element.code_name
      );
      if (index > -1) {
        let menus = window.jQuery(".uninstalled .dropdown.is-pulled-right");
        let trgt = menus[index];
        trgt.classList.remove("is-active");
      }
    },
    show_un_menu(element) {
      let v = this;
      let index = v.uninstalled_modules.findIndex(
        (m) => m.code_name == element.code_name
      );
      if (index > -1) {
        let menus = window.jQuery(".uninstalled .dropdown.is-pulled-right");
        let trgt = menus[index];
        trgt.classList.add("is-active");

        window
          .jQuery(trgt)
          .find(".dropdown-item")
          .on("click", function () {
            trgt.classList.remove("is-active");
          });

        // window.jQuery(trgt).on("click", function () {
        //   trgt.classList.remove("is-active");
        // });

        for (let i = 0; i < menus.length; i++) {
          if (i != index) {
            menus[i].classList.remove("is-active");
          }
        }
      }
    },
    toggle_menu(element) {
      let v = this;
      let index = v.modules.findIndex((m) => m.code_name == element.code_name);
      if (index > -1) {
        let menus = window.jQuery(".dropdown.is-pulled-right");
        let trgt = menus[index];
        trgt.classList.toggle("is-active");

        window
          .jQuery(trgt)
          .find(".dropdown-item")
          .on("click", function () {
            trgt.classList.remove("is-active");
          });

        for (let i = 0; i < menus.length; i++) {
          if (i != index) {
            menus[i].classList.remove("is-active");
          }
        }
      }
    },
    move(movement) {
      if (movement.moved.element.module_id)
        post("/module/order", {
          old_index: movement.moved.oldIndex,
          new_index: movement.moved.newIndex,
          module_id: movement.moved.element.module_id,
          code_name: movement.moved.element.code_name,
        })
          .then(() => {})
          .catch((error) => {
            error_message(error);
          });
    },
    technical_docs(mdle) {
      this.$router.push({
        path: `/module/technical-docs/${mdle.code_name}`,
      });
      // window.open(
      //   `/module/technical-docs/${mdle.code_name}`,
      //   "_blank",
      //   "noopener"
      // );
    },
  },
  mounted() {
    let v = this;
    v.init();
    setTimeout(() => {
      window
        .jQuery(".options-menu")
        .find(".dropdown-item")
        .on("mouseenter", function () {
          window.jQuery(this).addClass("is-active");
        })
        .on("mouseleave", function () {
          window.jQuery(this).removeClass("is-active");
        });
    }, 1000);
  },
  watch: {
    search() {
      let v = this;
      if (v.search) {
        let search = v.search.toLowerCase();
        v.installed_modules = v.installed_modules.map((m) => {
          m.matches_search = v.$t(m.home_title).toLowerCase().includes(search);
          return m;
        });
        v.uninstalled_modules = v.uninstalled_modules.map((m) => {
          m.matches_search = v.$t(m.home_title).toLowerCase().includes(search);
          return m;
        });
      } else {
        v.installed_modules = v.installed_modules.map((m) => {
          m.matches_search = true;
          return m;
        });
        v.uninstalled_modules = v.uninstalled_modules.map((m) => {
          m.matches_search = true;
          return m;
        });
      }
    },
  },
};
</script>

<style scoped></style>
